import {MenuItem} from '@material-ui/core';
import {DebtorActionType} from './DebtorActionHelper';
import React from 'react';
import {useHistory} from 'react-router-dom';

const DebtorShowPaymentsAction = React.forwardRef(({ debtor, setMenuAnchor, label }: DebtorActionType, ref: React.Ref<any>) => {
  const history = useHistory();
  return (
    <MenuItem
      ref={ref}
      key={debtor.id + 'newPayment'}
      onClick={() => {
        setMenuAnchor(null);

        history.push(`/dashboard/debitors/${debtor.id}/${debtor.emailAddress}/payments`);
      }}
    >
      {label}
    </MenuItem>
  );
});

export default DebtorShowPaymentsAction;
